import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { ThemeToggle } from "@/components/site/ThemeToggle";
import { useAuth } from "@/context/AuthContext";

const LINKS = [
  ["How It Works", "/#how-it-works"],
  ["Why We Vet", "/#why-we-vet"],
  ["Membership", "/#tiers"],
  ["FAQ", "/#faq"],
  ["News", "/announcements"],
  ["Contact", "/#contact"],
];

export const Logo = () => (
  <Link to="/" data-testid="nav-logo-link" className="flex items-center gap-2 group">
    <span className="h-9 w-[76px] rounded-lg bg-[#0A1F13] dark:bg-transparent px-1 grid place-items-center group-hover:scale-105 transition-transform">
      <img src="/images/logo_mark.png" alt="ITPN logo" className="h-full w-full object-contain" />
    </span>
    <span className="hidden sm:inline whitespace-nowrap font-display font-bold text-lg tracking-tight">
      I'm The Plug <span className="text-primary">Now</span>
    </span>
  </Link>
);

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const portal = user ? (user.role === "admin" ? "/admin" : "/member") : "/login";
  return (
    <header className="fixed top-0 inset-x-0 z-50 glass border-b border-border/60" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-7 text-sm font-semibold">
          {LINKS.map(([label, href]) => (
            <a key={href} href={href} className="text-muted-foreground hover:text-foreground transition-colors" data-testid={`nav-${label.toLowerCase().replace(/\s/g, "-")}`}>
              {label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <ThemeToggle />
          <Link to={portal} data-testid="nav-login-link" className="hidden sm:inline-flex h-10 items-center px-4 rounded-full text-sm font-semibold hover:bg-secondary transition-colors">
            {user ? "My Portal" : "Member Login"}
          </Link>
          <Link to="/apply" data-testid="nav-apply-button" className="hidden sm:inline-flex h-10 items-center px-5 rounded-full bg-primary text-primary-foreground text-sm font-bold btn-glow hover:-translate-y-0.5 transition-transform">
            Apply
          </Link>
          <button className="lg:hidden h-10 w-10 grid place-items-center rounded-full border border-border" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
            {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-border bg-background px-5 py-4 flex flex-col gap-3" data-testid="nav-mobile-menu">
          {LINKS.map(([label, href]) => (
            <a key={href} href={href} onClick={() => setOpen(false)} className="py-1 font-semibold">{label}</a>
          ))}
          <Link to={portal} className="py-1 font-semibold">{user ? "My Portal" : "Member Login"}</Link>
          <Link to="/apply" className="mt-1 h-11 grid place-items-center rounded-full bg-primary text-primary-foreground font-bold">Apply for Membership</Link>
        </div>
      )}
    </header>
  );
};
